import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {
  type RepoStacksListResponse,
  RepoStacksListResponseSchema,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_stacks'
import {repoAppBuilder} from '@github-ui/repo-app-builder'

export const REPO_STACKS_LIST_PATH = '/:owner/:repo/stacks'

export const STACKS_STATES = ['open', 'completed'] as const
export type StacksState = (typeof STACKS_STATES)[number]
export const STACKS_SORTS = ['newest', 'oldest'] as const
export type StacksSort = (typeof STACKS_SORTS)[number]

export function stacksListPath({owner, repo}: {owner: string; repo: string}) {
  return `/${owner}/${repo}/stacks`
}

/** The server's query params for a stacks list URL. Defaults are left out so each URL has one cache key. */
function stacksSearchParams(searchParams: URLSearchParams) {
  const params: Record<string, string> = {}
  const state = searchParams.get('state')
  const sort = searchParams.get('sort')
  const page = searchParams.get('page')
  if (state && state !== 'open' && STACKS_STATES.includes(state as StacksState)) params.state = state
  if (sort && sort !== 'newest' && STACKS_SORTS.includes(sort as StacksSort)) params.sort = sort
  if (page && page !== '1') params.page = page
  return params
}

export function buildRepoStacksListRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('repoStacksListRoute', {
    path: REPO_STACKS_LIST_PATH,
    queries: [
      mainQuery<RepoStacksListResponse>({
        schema: RepoStacksListResponseSchema,
        queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: stacksSearchParams(searchParams)}),
      }),
    ],
  })
}

export const repoStacksListRoute = buildRepoStacksListRoute(repoAppBuilder)
